import React, { useRef, useState } from "react";
import '../top-frames/Top_frames.css'
import Common_title from '../../common-components/common-title/Common_title'

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import 'swiper/css/pagination';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import Frames_card from "../../common-components/common-card/frame-card/Frames_card";

const Define_style_EyeGlasses = ({ products,name }) => {
  
    
    return (
        <>
            <section className='Top_frames_section'>
                <div className='container'>
                    <Common_title title={name} titleblack={'that define style'} />

                    <div className='framesslider_sec'>
                        <Swiper
                            slidesPerView={1}
                            centeredSlides={false}
                            navigation={true}
                            autoplay={{
                                delay: 2000,
                                disableOnInteraction: false,
                            }}
                            breakpoints={{
                                0: {
                                    slidesPerView: 2,
                                    spaceBetween: 5,
                                },
                                575: {
                                    slidesPerView: 3,
                                    spaceBetween: 5,
                                },
                                991: {
                                    slidesPerView: 3,
                                    spaceBetween: 10,
                                },
                                1200: {
                                    slidesPerView: 4,
                                    spaceBetween: 10,
                                },
                            }}

                            className="mySwiper"
                            modules={[Autoplay, Navigation]}
                        >
                            {products?.data?.map((data, index) => (
                                <SwiperSlide>
                                    <Frames_card
                                        image={data?.image}
                                        id={data?.id}
                                        type={`${data?.p_category?.name}`}
                                        name={data?.Brand?.name}
                                        prise={data?.price}
                                        oldprise={data?.mrp}
                                    />
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>


                </div>
            </section>
        </>
    )
}

export default Define_style_EyeGlasses